import React, { useContext } from 'react';
import {ActivityContext} from '../../index';
import { Radio } from '@alifd/next';
import styles from '../../index.module.scss';

function PaymentReminderType() {
  const { task, taskParams, setTaskParams, pageDisable } = useContext(ActivityContext);
  return (
    <div className={styles['cardBox']}>
      <div className={styles['titleBox']}>催付类型：</div>
        <Radio.Group
          direction={'hoz'}
          value={taskParams.triggerEvent[task].paymentReminderType}
          disabled={pageDisable}
          onChange={(v) =>{
            let newTriggerEventTask = {...taskParams.triggerEvent[task]}
            setTaskParams({
              ...taskParams,
              triggerEvent:{
                [task]:{
                  ...newTriggerEventTask,
                  paymentReminderType:+v
                }
              }
            })
          }}
        >
        <Radio value={1}>
          尾款催付
        </Radio>
        <Radio value={2}>
          定金催付
        </Radio>
      </Radio.Group>
    </div>
  );
}

export default PaymentReminderType;
